import { useContext } from 'react';

import AppConfigContext from '../context/AppConfig';

const useAppConfig = () => useContext(AppConfigContext);


export default useAppConfig